import * as joint from '@joint/core'

/**
 * C4 Component shape - box with component icon in corner
 */
export const C4Component = joint.dia.Element.define(
  'c4.Component',
  {
    size: { width: 240, height: 160 },
    attrs: {
      body: {
        refWidth: '100%',
        refHeight: '100%',
        rx: 10,
        ry: 10,
        fill: '#85bbf0',
        stroke: '#5d99c6',
        strokeWidth: 2,
      },
      // Component icon - two small rectangles sticking out from left side
      iconBox1: {
        x: -8,
        y: 15,
        width: 16,
        height: 10,
        rx: 2,
        ry: 2,
        fill: '#85bbf0',
        stroke: '#5d99c6',
        strokeWidth: 2,
      },
      iconBox2: {
        x: -8,
        y: 30,
        width: 16,
        height: 10,
        rx: 2,
        ry: 2,
        fill: '#85bbf0',
        stroke: '#5d99c6',
        strokeWidth: 2,
      },
      nameLabel: {
        refX: '50%',
        refY: 25,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#000000',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: 45,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#000000',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Component]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: 75,
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#000000',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '90%',
          height: 70,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      {
        tagName: 'rect',
        selector: 'body',
      },
      {
        tagName: 'rect',
        selector: 'iconBox1',
      },
      {
        tagName: 'rect',
        selector: 'iconBox2',
      },
      {
        tagName: 'text',
        selector: 'nameLabel',
      },
      {
        tagName: 'text',
        selector: 'typeLabel',
      },
      {
        tagName: 'text',
        selector: 'descriptionLabel',
      },
    ],
  }
)

export function createComponent(
  id: string,
  name: string,
  technology: string = '',
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const typeText = technology ? `[Component: ${technology}]` : '[Component]'

  const component = new C4Component({
    id,
    position: { x, y },
    attrs: {
      body: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      iconBox1: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      iconBox2: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: typeText,
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return component
}
